export class GetPayersRequest {
    BusinessName?: string;
    StreetNumber?: string;
    StreetName?: string;
    City?: string;
    State?: string;
    PostalCode?: string;
    POBoxNumber?: string;
    Latitude?: number;
    Longitude?: number;
    
}

export default GetPayersRequest;